<template>
  <PageSection :use-alternate-bg-color="useAlternateBgColor">
    <PageContainer>
      <PageHeading tag-name="h1">
        {{ $t('csr.section.projects.title') }}
      </PageHeading>
    </PageContainer>

    <PageCollectionCarousel align="center">
      <CsrCardItem
        v-for="item in items"
        :key="item.image"
        :item="item"
      />
    </PageCollectionCarousel>
  </PageSection>
</template>

<script lang="ts">
import PageCardContent, { PageCardContentProps } from '@/scripts/pages/onepager/components/PageCardContent.ts.vue';
import PageSection from '@/scripts/pages/onepager/components/PageSection.ts.vue';
import PageContainer from '@/scripts/pages/onepager/components/PageContainer.ts.vue';
import PageHeading from '@/scripts/pages/onepager/components/PageHeading.ts.vue';
import PageCollectionCarousel from '@/scripts/pages/onepager/components/PageCollectionCarousel.ts.vue';
import { CsrBaseComponent } from '../components/CsrBaseComponent';
import CsrCardItem from '../components/CsrCardItem.ts.vue';
import { PROJECT_SECTION_IMAGES } from '../assets/media';
import { LocaleItemWithAction, LocaleItemAction } from '../types/LocaleItem';

interface CardItem extends PageCardContentProps {
  action: LocaleItemAction & {
    href: string;
  };
}

const hrefs = [
  'https://www.viddsee.com/s/storiestogethersg',
  'https://www.viddsee.com/series/add-a-new-story',
  'https://www.viddsee.com/series/my-kosong-plan',
  'https://www.viddsee.com/video/the-story-behind-finding-purpose/k0jon ',
  'https://www.viddsee.com/video/open-doors-singapore/ixb54',
  'https://www.viddsee.com/video/gift/og4gr ',
  'https://www.viddsee.com/series/15-shorts',
];

export default CsrBaseComponent.extend({
  components: {
    PageCardContent,
    PageSection,
    PageContainer,
    PageHeading,
    PageCollectionCarousel,
    CsrCardItem,
  },
  props: {
    useAlternateBgColor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const localeItems: LocaleItemWithAction[] = this.$t('csr.section.projects.items');
    const items: CardItem[] = localeItems.map(({ title, paragraphs, action }, index) => ({
      content: {
        title,
        paragraphs,
      },
      image: PROJECT_SECTION_IMAGES[index],
      action: {
        label: action.label,
        href: hrefs[index],
      },
    }));

    return {
      items,
    };
  },
});
</script>
